import React from 'react';
import { Box, Typography, ButtonBase } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

interface SelectableCardProps {
  title: string;
  description: string;
  image: string;
  selected: boolean;
  onToggle: () => void;
  imageHeight?: number;
}

const SelectableCard: React.FC<SelectableCardProps> = ({
  title,
  description,
  image,
  selected,
  onToggle,
  imageHeight = 160,
}) => {
  return (
    <ButtonBase
      onClick={onToggle}
      focusRipple
      sx={{
        display: 'block',
        width: '100%',
        height: '100%',
        textAlign: 'left',
        borderRadius: '12px',
        border: '2px solid',
        borderColor: selected ? 'primary.main' : 'divider',
        bgcolor: '#fff',
        overflow: 'hidden',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease',
        boxShadow: '0 1px 3px rgba(16, 24, 40, 0.06)',
        '&:hover': {
          borderColor: selected ? 'primary.main' : 'primary.light',
          boxShadow: '0 6px 16px rgba(16, 24, 40, 0.1)',
          transform: 'translateY(-2px)',
        },
      }}
      className={`selectable-card ${selected ? 'selected' : ''}`}
    >
      <Box sx={{ position: 'relative' }}>
        <Box
          component="img"
          src={image}
          alt={title}
          sx={{
            display: 'block',
            width: '100%',
            height: imageHeight,
            objectFit: 'cover',
            bgcolor: 'grey.100',
          }}
        />
        {selected && (
          <Box
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              width: 28,
              height: 28,
              borderRadius: '50%',
              bgcolor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
            }}
          >
            <CheckIcon sx={{ fontSize: 16, color: '#fff' }} />
          </Box>
        )}
      </Box>
      <Box sx={{ p: 2 }}>
        <Typography sx={{ fontWeight: 700, color: 'text.primary', fontSize: '1.05rem' }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5, minHeight: '2.6em' }}>
          {description}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontWeight: 700, color: 'primary.main', mt: 1.25 }}
        >
          {selected ? '✓ Ausgewählt' : '+ Auswählen'}
        </Typography>
      </Box>
    </ButtonBase>
  );
};

export default SelectableCard;
